import { takeLatest, takeEvery, fork, all } from 'redux-saga/effects';
import { withOffset } from '@wix/da-shared-react/pkg/Stream';
import { sagas as sharedSagas } from '@wix/da-shared-react/pkg/redux/shared';
import { sisuFunnelSaga } from '@wix/da-shared-react/pkg/redux/sisuFunnel/saga';
import { PATH_CHANGE } from '../actions/app';
import { FETCH_SECTION_SUCCESS } from '../actions/sections';
import fetchSectionData from './fetchSectionData';
import trackGoogleAnalyticsPageView from './trackGoogleAnalyticsPageView';
import callStreamSpecificSaga from './streams';
import { leaveGroup } from '../actions/groups';
import leaveGroupSaga from './groups';
import commissionSagas from './commissions';
import pollStreamSagas from './polls';
import deviationSagas from './deviation';
import rootModulesSaga from './modules';
import rootLayoutSaga from './layout';
import rootAvatarSaga from './avatar';
import rootCoverDeviationSaga from './coverDeviation';
import rootFeedSaga from './feed';
import rootDraftsSaga from './drafts';
import statsSection from './statsSection';
import biLogger from './biLogger';
import profileOwner from './profileOwner';
import gallectionSagas from './gallections';
import appSagas from './app';

export default function* rootSaga() {
  yield all([
    takeLatest(PATH_CHANGE, fetchSectionData),
    takeEvery(FETCH_SECTION_SUCCESS, trackGoogleAnalyticsPageView),
    takeEvery(
      withOffset.actions.STREAM__WITH_OFFSET__FETCH,
      callStreamSpecificSaga
    ),
    takeEvery(leaveGroup, leaveGroupSaga),
    ...deviationSagas,
    ...commissionSagas,
    ...gallectionSagas,
    ...pollStreamSagas,
    fork(rootLayoutSaga),
    fork(rootModulesSaga),
    fork(rootAvatarSaga),
    fork(rootCoverDeviationSaga),
    fork(rootFeedSaga),
    fork(rootDraftsSaga),
    fork(biLogger),
    fork(profileOwner),
    fork(statsSection),
    fork(appSagas),
    ...sharedSagas.map(fork),
    fork(sisuFunnelSaga),
  ]);
}
